(function () {
    function getSectionsToRender() {
      // match CartNotification.getSectionsToRender() IDs
      return ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
    }

    document.addEventListener('submit', async function (e) {
      const form = e.target.closest('form.js-qs-form[action="/cart/add"]');
      if (!form) return;

      e.preventDefault();
      e.stopPropagation();

      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }

      try {
        const fd = new FormData(form);

        // IMPORTANT: add Dawn "sections" payload so response has parsedState.sections
        fd.append('sections', getSectionsToRender().join(','));
        fd.append('sections_url', window.location.pathname);

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        });

        if (!res.ok) throw new Error('Add to cart failed');

        const parsedState = await res.json();

        const cartNotification = document.querySelector('cart-notification');
        if (cartNotification && typeof cartNotification.renderContents === 'function') {
          cartNotification.renderContents(parsedState);
        } else {
          // fallback
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error(err);
        window.location.href = '/cart';
      } finally {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
      }
    }, true);
  })();